import React, { Component } from 'react';

class Alert extends Component{

	constructor(){
		super();
		this.className = '';
		this.icon = '';
	}

	setAlertType = () => {
		switch(this.props.alertType){
			case 'SUCCESS':
			default:
				this.className = 'alert-success';
				this.icon = 'fa-check';
				break;
			case 'FAIL':
				this.className = 'alert-danger';
				this.icon = 'fa-times';
				break;
			case 'INFO':
				this.className = 'alert-info';
				this.icon = 'fa-info';
				break;
			case 'WARNING':
				this.className = 'alert-warning';
				this.icon = 'fa-exclamation';
				break;
		}
	};

	render(){
		const {rendered, alertMessage} = this.props;

		if(rendered === undefined || !rendered){
			return null;
		}

		this.setAlertType();

		return (
			<div className={'alert ' + this.className}>
				<i className={'fa ' + this.icon} /> {alertMessage}
			</div>
		);
	}
}

export default Alert;


// WEBPACK FOOTER //
// ./src/components/common/Alert.js